export const columns = [
  {
    name: 'Name',
    label: 'Name',
    options: {
      sortCompare: (obj) => (a, b) => {
        if (a.data && a.data.length > 0 && b.data && b.data.length > 0) {
          if (obj === 'asc') {
            return a.data[0] > b.data[0] ? -1 : 1;
          }
          return b.data[0] > a.data[0] ? -1 : 1;
        }
        return 0;
      },
    },
  },
];
